import React from 'react';
import BackTo from "../Components/LinkBackTo/LinkBackTo";
const ProductsAdmin = () => {
  return (
    <div>
     <BackTo move="/ProductsList" nameback="PRODUCTS"/> 
    </div>
  )
};

export default ProductsAdmin;
